import { PrizeSupplierService } from "./PrizeSupplier.service";

export default {
  prizeSupplierService: {
    class: PrizeSupplierService,
    public: true,
    arguments: [{ $ref: "apiService" }]
  }
};
